import React from 'react'
import { IMembersSelectorMembers } from '../MembersSelectors.types'
import { useMembersSelectorContext } from '../MembersSelectorContext'
import { observer } from 'mobx-react-lite'

type SyncStateProps = {
  membersFound: IMembersSelectorMembers
  addressBook?: IMembersSelectorMembers
  selectedMembers: IMembersSelectorMembers
  notifyParentOnChangeSelectedMembers: (
    members: IMembersSelectorMembers
  ) => void
}

/**
 * Update members autocomplete after address book is closed or when
 * autocomplete was changed
 * @param membersFound
 * @constructor
 */
export const SyncState: React.FC<SyncStateProps> = observer(
  ({
    membersFound,
    selectedMembers,
    notifyParentOnChangeSelectedMembers,
    addressBook
  }) => {
    const {
      setFoundMembers,
      setAddressBook,
      setSelectedMembers,
      setNotifyParentOnChangeSelectedMembers
    } = useMembersSelectorContext()

    React.useEffect(() => {
      setFoundMembers(membersFound)
    }, [membersFound.users, membersFound.groups])

    React.useEffect(() => {
      setAddressBook(addressBook)
    }, [addressBook?.users, addressBook?.groups])

    React.useEffect(() => {
      setSelectedMembers(selectedMembers)
    }, [selectedMembers.users, selectedMembers.groups])

    React.useEffect(() => {
      setNotifyParentOnChangeSelectedMembers(
        notifyParentOnChangeSelectedMembers
      )
    }, [notifyParentOnChangeSelectedMembers])

    return null
  }
)

SyncState.displayName = 'SyncState'
